import * as api from "api/endpoints/onboarding";
import { createSlice, createSliceSelector } from "../factory";

const name = "SystemSettingsPage";

const initialState = {
  matchConfidenceValues: {}
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectMatchConfidenceValues = createSelector((state) => {
  return state.matchConfidenceValues;
});

/* Actions */
const { update } = slice.actions;

export function loadMatchConfidenceValues(epId) {
  return async function (dispatch) {
    const data = await api.getMatchConfidenceSetup(epId);

    const payload = {
      matchConfidenceValues: data.details
    };

    dispatch(update(payload));
  };
}

export function updateMatchConfidenceValues(changedValue) {
  return async function (dispatch, getState) {
    const data = selectMatchConfidenceValues(getState());

    const newValues = Object.assign({}, data, changedValue);
    const payload = {
      matchConfidenceValues: newValues
    };

    dispatch(update(payload));
  };
}

export function submitMatchConfidenceValues(epId, data) {
  const { matchConfidenceScoreLowerLimit } = data;
  const config = { epId: epId, matchConfidenceScoreLowerLimit };
  return async function (dispatch) {
    api.postMatchConfidenceSetup(config).then(() => {
      dispatch(loadMatchConfidenceValues(epId));
    });
  };
}
